import { render, staticRenderFns } from "./Terrain.vue?vue&type=template&id=35445194&scoped=true&"
import script from "./Terrain.vue?vue&type=script&lang=js&"
export * from "./Terrain.vue?vue&type=script&lang=js&"
import style0 from "./Terrain.vue?vue&type=style&index=0&id=35445194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35445194",
  null
  
)

export default component.exports